<template>

  <div>    
    <vs-card>

     <vs-row vs-type="flex" vs-justify="space-between" class="mb-3">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1" v-if="!$store.state.AppActiveUser.hasOwnProperty('idVendedor')">
          <label class="vs-input--label">{{$t('TelaPedido_lVendedor')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3" v-if="!$store.state.AppActiveUser.hasOwnProperty('idVendedor')">          
            <v-select                                     
                  label="nome"  
                  :options="listaVendedores"                   
                  v-model="filtro.vendedor"       
                  class="v-select w-full"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lLoja')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <v-select                                     
                  label="nome"
                  :options="listaLojas"                   
                  v-model="filtro.loja"       
                  class="v-select w-full"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lZona')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <v-select
                  label="nome"                              
                  :options="listaZonas" 
                  v-model="filtro.zona"                        
                  class="v-select w-full"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4" v-if="$store.state.AppActiveUser.hasOwnProperty('idVendedor')"></vs-col>
        
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lPedido')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">          
            <vs-input class="mb-4 md:mb-0 w-full" v-model="filtro.numeroPedido" @keyup.enter.native="click_filtrar" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lCarregamento')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">          
            <vs-input class="mb-4 md:mb-0 w-full" v-model="filtro.numeroCarregamento" @keyup.enter.native="click_filtrar"/>
        </vs-col>  
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">
            <v-select                   
                :reduce="tipo => tipo.data" 
                :options="listaOpcoesFiltroData" 
                v-model="filtro.tipoDataPesquisa"       
                :clearable="false"
                class="v-select w-full text-sm ml-2 mr-2"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">
            <flat-pickr v-model="filtro.dataInicio" :config="configDatePicker"/>
            <label class="vs-input--label">à</label>
            <flat-pickr v-model="filtro.dataFim" :config="configDatePicker"/>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="3">
          <vs-button class="mr-2" radius color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
          <vs-button class="mr-2" radius color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
          <vs-button class="mr-2" radius color="dark" type="border" icon-pack="feather" icon="icon-log-out" @click="sairVendedor" v-if="$store.state.AppActiveUser.hasOwnProperty('idVendedor')"></vs-button>  
        </vs-col>    
       
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between" class="mt-2" v-if="exibirErro">        
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <vs-alert :active.sync="exibirErro" closable color="danger" icon-pack="feather" icon="icon-info" close-icon="icon-x">
               {{mensagemErro}}
            </vs-alert> 
        </vs-col>
      </vs-row>
    </vs-card>

    <vs-tabs alignment="fixed" v-model="tabSelecionada">
      <vs-tab label="Venda Finalizada" v-if="isTabVisible('gPedidoAba1')"> 
          <GerenciamentoPedidosAba1 :filtro="filtro" ref="aba1"/>
      </vs-tab>
      <vs-tab label="Liberado para Separação" v-if="isTabVisible('gPedidoAba2')"> 
          <GerenciamentoPedidosAba2 :filtro="filtro" ref="aba2"/>
      </vs-tab>
      <vs-tab label="Em Separação" v-if="isTabVisible('gPedidoAba3')"> 
          <GerenciamentoPedidosAba3 :filtro="filtro" ref="aba3"/>
      </vs-tab>
      <vs-tab label="Separados" v-if="isTabVisible('gPedidoAba4')"> 
          <GerenciamentoPedidosAba4 :filtro="filtro" ref="aba4"/>
      </vs-tab>
      <vs-tab label="Liberados para Roteirização" v-if="isTabVisible('gPedidoAba5')"> 
          <GerenciamentoPedidosAba5 :filtro="filtro" ref="aba5"/>
      </vs-tab>
      <vs-tab label="Não Entregues" v-if="isTabVisible('gPedidoAba5')"> 
          <GerenciamentoPedidosAba6 :filtro="filtro" ref="aba6"/>
      </vs-tab>
    </vs-tabs>
       
  </div>

</template>

<script>
import axios from "@/axios.js"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import GerenciamentoPedidosAba1 from './Aba1/GerenciamentoPedidos-Aba1'
import GerenciamentoPedidosAba2 from './Aba2/GerenciamentoPedidos-Aba2'
import GerenciamentoPedidosAba3 from './Aba3/GerenciamentoPedidos-Aba3'
import GerenciamentoPedidosAba4 from './Aba4/GerenciamentoPedidos-Aba4'
import GerenciamentoPedidosAba5 from './Aba5/GerenciamentoPedidos-Aba5'
import GerenciamentoPedidosAba6 from './Aba6/GerenciamentoPedidos-Aba6'

const CONSTANTE_OPCAO_DATA_ARRAY = [	
	{label:"Dt. Venda", data:"VENDA"},		
	{label:"Compr. Entrega", data:"COMPROMISSO_ENTREGA"},
	{label:"Dt. Renegociação", data:"RENEGOCIACAO"}
];

export default {
  components: {    
    flatPickr,
    GerenciamentoPedidosAba1,
    GerenciamentoPedidosAba2,
    GerenciamentoPedidosAba3,
    GerenciamentoPedidosAba4,
    GerenciamentoPedidosAba5,
    GerenciamentoPedidosAba6,
  },
  data() {
    return {
      tabSelecionada: 0,
      filtro: {vendedor: null, loja: null, zona: null, numeroPedido: null, numeroCarregamento: null, tipoDataPesquisa: 'VENDA', dataInicio: null,
      dataFim: null, statusItinerario: null},
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "U", 
          altInputClass: "vs-inputx vs-input--input normal text-sm  hasValue text-center",
          locale: PortugueseLocale
      },     
      dadosDaGridVendaFinalizada: [],
      totalRegistros: 0,
      listaLojas: [],
      listaVendedores: [],
      listaZonas:[],
      exibirErro: false,
      mensagemErro: null,
    }
  },  
  computed: {   
    
  },
  methods: {   
    sairVendedor() {
        this.$router.push({
            name: 'page-login-vendedor-roteirizacao'
        })
    },
    click_filtrar() {       
      this.fetchLista(this.filtro);  
    }, 
    limparFiltros() {
      this.filtro = {vendedor: null, loja: null, zona: null, numeroPedido: null, numeroCarregamento: null, tipoDataPesquisa: 'VENDA', dataInicio: null, dataFim: null, statusItinerario: null};
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = String(firstDay.getTime()/1000);
      this.filtro.dataFim = String(lastDay.getTime()/1000); 
      this.tipoDataPesquisa = 'VENDA';
    },
    fetchLista(filtro) {    
      if (this.$store.state.AppActiveUser.hasOwnProperty('idVendedor')) {
        filtro.vendedor = {id: this.$store.state.AppActiveUser.idVendedor };        
      }

      console.log("Filtro=" + JSON.stringify(filtro));

      if (this.tabSelecionada === 0) {
        this.$refs.aba1.fetchLista(filtro);
      } else if (this.tabSelecionada === 1) {
        this.$refs.aba2.fetchLista(filtro);
      } else if (this.tabSelecionada === 2) {
        this.$refs.aba3.fetchLista(filtro);
      } else if (this.tabSelecionada === 3) {
        this.$refs.aba4.fetchLista(filtro);
      } else if (this.tabSelecionada === 4) {
        this.$refs.aba5.fetchLista(filtro);
      } else if (this.tabSelecionada === 5) {
        this.$refs.aba6.fetchLista(filtro);
      }
    },    
    fetchVendedores() {      
      const params = new URLSearchParams();
      params.append('method', 'FindAll');
      params.append('orderDirection', 'ASC');
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      
      axios.post("VendedorRotasRestServlet", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.listaVendedores = response.data;
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista Fornecedor - " + error); 
      })    
    },
    fetchLojas() {      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        axios.post("LojasRotasRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                this.listaLojas = response.data;
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista Fornecedor - " + error); 
        })    
    },
    fetchZonas() {      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        axios.post("ZonasRotasRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                this.listaZonas = response.data;
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista Fornecedor - " + error); 
        })    
    },
    isTabVisible(nomeTab) {
      if (this.$store.state.AppActiveUser.hasOwnProperty(nomeTab)) {
          return this.$store.state.AppActiveUser[nomeTab];
      }

      return true;
    }
  },    
  created() {   
    this.listaOpcoesFiltroData = CONSTANTE_OPCAO_DATA_ARRAY; 
  },
  mounted() {
    this.fetchLojas();
    this.fetchVendedores();
    this.fetchZonas();
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 270px);
  }
</style>

<style lang="scss">  
.con-vs-dialog {    
    .vs-dialog {
      max-width: 1000px;      
    }
}
</style>